<mat-card class="restriction-card-skeleton" [style.height.px]="isSmall ? 250 : 310">
  <div class="restriction-card-skeleton__header cm-card__header">
    <div class="card-title-container w-100 mt-3">
      <cm-skeleton-fade width="50%" marginBottom="0"></cm-skeleton-fade>
    </div>
  </div>
  <mat-card-content>
    <div class="restriction-card-skeleton__card">
      <div class="restriction-card-skeleton__card--header">
        <cm-skeleton-fade marginBottom="0"></cm-skeleton-fade>
        <cm-skeleton-fade marginBottom="0"></cm-skeleton-fade>
      </div>
      <div class="restriction-card-skeleton__card--content pt-3">
        <div>
          <cm-skeleton-fade class="w-100"></cm-skeleton-fade>
          <cm-skeleton-fade class="w-100" appearance="chip" [count]="5"></cm-skeleton-fade>
        </div>
        <div *ngIf="!isSmall" class="mt-3">
          <cm-skeleton-fade class="w-100"></cm-skeleton-fade>
          <cm-skeleton-fade class="w-100" appearance="chip" [count]="5"></cm-skeleton-fade>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
